import { render } from "./About.vue?vue&type=template&id=180ce65d&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=180ce65d&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180ce65d"]])

export default __exports__